export const Alerts = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.54873 4.5498C3.1538 5.94474 2.29102 7.87182 2.29102 10.0004C2.29102 12.129 3.1538 14.0561 4.54873 15.451M6.97123 6.9723C6.19627 7.74726 5.71694 8.81787 5.71694 10.0004C5.71694 11.183 6.19627 12.2536 6.97123 13.0285M13.0275 13.0285C13.8024 12.2536 14.2818 11.183 14.2818 10.0004C14.2818 8.81787 13.8024 7.74726 13.0275 6.9723M15.45 15.451C16.8449 14.0561 17.7077 12.129 17.7077 10.0004C17.7077 7.87182 16.8449 5.94474 15.45 4.5498M10.6243 9.9998C10.6243 10.345 10.3445 10.6248 9.99935 10.6248C9.65417 10.6248 9.37435 10.345 9.37435 9.9998C9.37435 9.65463 9.65417 9.3748 9.99935 9.3748C10.3445 9.3748 10.6243 9.65463 10.6243 9.9998Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Alerts
